module.exports = __webpack_public_path__ + "img/zxsign6.c3b8916d.png";